import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import Campaign from 'features/ad/campaign/Campaign'
import AdGroup from 'features/ad/group/AdGroup'
import Keyword from 'features/ad/keyword/Keyword'
import GroupCreative from 'features/ad/creative/GroupCreative'
import ProgressBar from './progressBar/ProgressBar'

const AdManagementRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <>
      <ProgressBar />
      <Switch>
        <Route exact path={`${path}/campaigns/new`}>
          <Campaign />
        </Route>
        <Route exact path={`${path}/campaigns/:campaignId(\\d+)`}>
          <Campaign modify />
        </Route>
        <Route exact path={`${path}/campaigns/:campaignId(\\d+)/groups/new`}>
          <AdGroup />
        </Route>
        <Route
          exact
          path={`${path}/campaigns/:campaignId(\\d+)/groups/:adGroupId(\\d+)`}>
          <AdGroup modify />
        </Route>
        <Route
          exact
          path={`${path}/campaigns/:campaignId(\\d+)/groups/:adGroupId(\\d+)/keywords`}>
          <Keyword />
        </Route>
        <Route
          exact
          path={`${path}/campaigns/:campaignId(\\d+)/groups/:adGroupId(\\d+)/addKeywords`}>
          <Keyword modify />
        </Route>
        <Route
          path={`${path}/campaigns/:campaignId(\\d+)/groups/:adGroupId(\\d+)/creatives`}>
          <GroupCreative />
        </Route>
        <Redirect to={`${path}/campaigns/new`} />
      </Switch>
    </>
  )
}
export default AdManagementRoutes
